export const urls = {
  userLogin: "/api/users/login",
  userSignup: "/api/users/signup",
  SUBMIT_SURVEY: "/api/survey/submit-answers",
  GET_USER_TEAMS: "/api/team/get-user-teams",
  GET_USER_TEAMS: "/api/team/get-user-teams",
  ADD_NEW_TEAM_CODE: "/api/users/register-in-team",
  SWITCH_TEAM: "/api/users/switch-team",
};
